
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Package, ShoppingCart, Star, Users } from "lucide-react";
import { useEffect } from "react";
import useCustomerJourney from "@/hooks/useCustomerJourney";

const Index = () => {
  const { trackPageView } = useCustomerJourney();

  useEffect(() => {
    trackPageView('home', {
      page_title: 'Dough Man - Home',
      section: 'homepage'
    });
  }, [trackPageView]);
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary/10 via-primary/5 to-background py-20 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Welcome to <span className="text-primary">Dough Man</span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Your premier destination for fresh, artisanal baked goods. 
            From warm bread to delicate pastries, we deliver quality straight to your door.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" asChild>
              <Link to="/products" className="flex items-center gap-2">
                  Shop Now <ArrowRight className="h-5 w-5" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <Link to="/products" className="flex items-center gap-2">
                Browse Products <ArrowRight className="h-5 w-5" />
              </Link>
            </Button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12">Why Choose Dough Man?</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="text-center p-6">
              <CardContent className="pt-6">
                <Package className="h-12 w-12 text-primary mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">Fresh Daily</h3>
                <p className="text-gray-600">
                  All our products are baked fresh daily using premium ingredients and traditional recipes.
                </p>
              </CardContent>
            </Card>
            <Card className="text-center p-6">
              <CardContent className="pt-6">
                <ShoppingCart className="h-12 w-12 text-primary mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">Easy Ordering</h3>
                <p className="text-gray-600">
                  Simple online ordering with flexible delivery options to fit your schedule.
                </p>
              </CardContent>
            </Card>
            <Card className="text-center p-6">
              <CardContent className="pt-6">
                <Star className="h-12 w-12 text-primary mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">Premium Quality</h3>
                <p className="text-gray-600">
                  Handcrafted with care by experienced bakers who are passionate about their craft.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-primary text-primary-foreground py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Experience Dough Man?</h2>
          <p className="text-xl mb-8 opacity-90">
            Join thousands of satisfied customers who trust us for their daily bread and special occasions.
          </p>
          <Button size="lg" variant="secondary" asChild>
            <Link to="/auth" className="flex items-center gap-2">
              Get Started Today
              <Users className="h-5 w-5" />
            </Link>
          </Button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h3 className="text-2xl font-bold mb-4">Dough Man</h3>
          <p className="text-gray-400 mb-6">
            Bringing you the finest baked goods since day one.
          </p>
          <div className="flex justify-center space-x-6 mb-6">
            <Link to="/products" className="text-gray-400 hover:text-white transition-colors">
              Products
            </Link>
            <Link to="/auth" className="text-gray-400 hover:text-white transition-colors">
              Sign In
            </Link>
          </div>
          
          {/* Development Test Link */}
          <div className="border-t border-gray-700 pt-6">
            <Link
              to="/test-payment"
              className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-600 text-yellow-100 rounded-lg hover:bg-yellow-500 transition-colors text-sm font-medium"
            >
              🧪 Test Kowri Payment Integration
            </Link>
            <p className="text-xs text-gray-500 mt-2">Development testing only</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;
